import Vue from 'vue';
import fvWidth from "./fvWidth"
import fvWindowOpen from "./fvWindowOpen"
import fvBoolInput from "./fvBoolInput"
import fvColorTransform from "./fvColorTransform"
import fvContextMenu from "./fvContextMenu"
import fvFlow from "./fvFlow"
import fvForbid from "./fvForbid"
import fvGeneralOperation from "./fvGeneralOperation"
import fvHeight from "./fvHeight"
import fvHide from "./fvHide"
import fvHorDrag from "./fvHorDrag"
import fvHorFill from "./fvHorFill"
import fvHorMove from "./fvHorMove"
import fvLineColor from "./fvLineColor"
import fvLmousescript from "./fvLmousescript"
import fvMessage from "./fvMessage"
import fvMousescript from "./fvMousescript"
import fvOutput from "./fvOutput"
import fvOutputChar from "./fvOutputChar"
import fvOutputSwitch from "./fvOutputSwitch"
import fvRmousescript from "./fvRmousescript"
import fvRotateMove from "./fvRotateMove"
import fvStringInput from "./fvStringInput"
import fvTextColor from "./fvTextColor"
import fvTwinkel from "./fvTwinkel"
import fvVarInput from "./fvVarInput"
import fvVerticalDrag from "./fvVerticalDrag"
import fvVerticalFill from "./fvVerticalFill"
import fvVerticalMove from "./fvVerticalMove"
Vue.prototype.fvWidth = fvWidth;
Vue.prototype.fvWindowOpen = fvWindowOpen;
Vue.prototype.fvBoolInput = fvBoolInput;
Vue.prototype.fvColorTransform = fvColorTransform;
Vue.prototype.fvContextMenu = fvContextMenu;
Vue.prototype.fvFlow = fvFlow;
Vue.prototype.fvForbid = fvForbid;
Vue.prototype.fvGeneralOperation = fvGeneralOperation;
Vue.prototype.fvHeight = fvHeight;
Vue.prototype.fvHide = fvHide;
Vue.prototype.fvHorDrag = fvHorDrag;
Vue.prototype.fvHorFill = fvHorFill;
Vue.prototype.fvHorMove = fvHorMove;
Vue.prototype.fvLineColor = fvLineColor;
Vue.prototype.fvLmousescript = fvLmousescript;
Vue.prototype.fvMessage = fvMessage;
Vue.prototype.fvMousescript = fvMousescript;
Vue.prototype.fvOutput = fvOutput;
Vue.prototype.fvOutputChar = fvOutputChar;
Vue.prototype.fvOutputSwitch = fvOutputSwitch;
Vue.prototype.fvRmousescript = fvRmousescript;
Vue.prototype.fvRotateMove = fvRotateMove;
Vue.prototype.fvStringInput = fvStringInput;
Vue.prototype.fvTextColor = fvTextColor;
Vue.prototype.fvTwinkel = fvTwinkel;
Vue.prototype.fvVarInput = fvVarInput;
Vue.prototype.fvVerticalDrag = fvVerticalDrag;
Vue.prototype.fvVerticalFill = fvVerticalFill;
Vue.prototype.fvVerticalMove = fvVerticalMove;


// WEBPACK FOOTER //
// ./src/js/canvas/animation/index.js